<template>
  <div class="container verify-recipe">
    <b-overlay :show="loading" opacity="0.99">
      <div v-if="errors.length > 0">
        <div class="alert alert-danger text-center" role="alert">
          <h4 class="alert-heading">Ops!</h4>
          <p>
            {{ errors[0] }}
          </p>
          <hr />
          <p class="mb-0">Entre em contato com a ILPI.</p>
        </div>
      </div>
      <div v-if="errors.length == 0 && exist">
        <table
          class="bg-white table-important"
          v-for="table in tables"
          :key="table"
        >
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div style="page-break-after: always !important">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div>
                        <img
                          style="
                            height: 80px !important;
                            object-fit: cover !important;
                          "
                          v-if="client.logo_url"
                          class="rest_home_logo_url"
                          :src="client.logo_url"
                        />
                        <div v-if="!client.logo_url" class="ml-1">
                          <strong class="text-uppercase">{{
                            client.name
                          }}</strong>
                        </div>
                      </div>
                      <div class="ml-5">
                        <b style="font-size: 28px !important">{{
                          doctor.name
                        }}</b>
                        <div>
                          {{ doctor.professional_class_council_value }}
                        </div>
                      </div>
                      <div>
                        <img
                          width="100px"
                          height="100px"
                          v-if="imgQRCode"
                          :src="imgQRCode"
                        />
                      </div>
                    </div>

                    <div v-if="data_qrcode.status == 0">
                      <h5 class="text-center bg-warning">
                        RECEITA JÁ FOI VALIDADA.
                      </h5>
                    </div>

                    <!-- IDENTIFICAÇÃO DO EMITENTE -->
                    <div class="identificacao-do-emitente row m-0">
                      <div
                        class="identificacao-do-emitente-left col-md-7"
                        v-if="data[0].type_of_recipe_name != 'RECEITA COMUM'"
                      >
                        <h4>IDENTIFICAÇÃO DO EMITENTE</h4>
                        <div><b>Nome:</b> {{ doctor.name }}</div>
                        <div>
                          <b>CRM:</b>
                          {{ doctor.professional_class_council_value }}
                        </div>
                        <div>
                          <b>Endereço:</b> {{ client.address }}
                          {{ client.num_address }}
                        </div>
                        <div>
                          <b>Telefone:</b>
                          {{
                            client.first_phone
                              ? client.first_phone
                              : client.second_phone
                          }}
                        </div>
                        <div>
                          <b>Cidade e UF:</b> {{ client.city }} -
                          {{ client.uf_name }}
                        </div>
                      </div>
                      <div
                        class="identificacao-do-emitente-right col-md-5"
                        v-if="data[0].type_of_recipe_name != 'RECEITA COMUM'"
                      >
                        <h2 v-if="tables == 2 && table == 1">1ª VIA</h2>
                        <h4 v-if="tables == 2 && table == 1">
                          {{ data[0].type_of_recipe_name }}
                        </h4>
                        <h2 v-if="tables == 2 && table != 1">2ª VIA</h2>
                        <h4 v-if="tables == 2 && table != 1">
                          {{ data[0].type_of_recipe_name }}
                        </h4>
                        <h2 v-if="tables != 2">1ª VIA</h2>
                        <h4 v-if="tables != 2">
                          {{ data[0].type_of_recipe_name }}
                        </h4>
                        <hr style="width: 100% !important" />
                        <b>ASSINATURA</b>
                      </div>
                    </div>
                    <!-- IDENTIFICAÇÃO DO EMITENTE -->
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div
                  class="content"
                  v-show="i.length > 0"
                  v-for="(i, k) in separateData"
                  :key="k"
                >
                  <div v-if="data[0].type_of_recipe_name == 'RECEITA COMUM'">
                    <h4>{{ data[0].type_of_recipe_name }}</h4>
                  </div>
                  <div class="d-flex">
                    <p class="m-0">RESIDENTE:</p>
                    <span class="ml-2">{{ resident.name }}</span>
                  </div>
                  <div class="d-flex mb-5">
                    <p class="m-0">Endereço:</p>
                    {{ client.address }}
                    {{ client.num_address }}
                    {{ client.address ? "," : "" }} {{ client.city }}
                    {{ client.city ? "," : "" }}
                    {{ client.uf_name }}
                  </div>
                  <div
                    v-for="medicine in i"
                    :key="medicine.id"
                    class="page-break-inside-avoid"
                  >
                    <div class="row m-0">
                      <div class="col-md-6 p-0">
                        <p class="m-0">{{ medicine.name }}</p>
                        <p class="m-0 worksansr">
                          {{
                            String(medicine.active_ingredient_name).length > 10
                              ? `${String(
                                  medicine.active_ingredient_name
                                ).substring(0, 50)}...`
                              : medicine.active_ingredient_name
                          }}
                        </p>
                      </div>
                      <div class="col-md-6 p-0">
                        <div
                          v-if="
                            medicine.medicine_amount_of_times_type == 'SHIFTS'
                          "
                          class="text-thirteen"
                        >
                          <div v-if="medicine.dawn && medicine.dawn_quantity">
                            <span>MADRUGADA:</span>
                            <span>
                              {{
                                medicine.drops_dawn_quantity
                                  ? `${medicine.drops_dawn_quantity} GOTA(S)`
                                  : medicine.ui_dawn_quantity
                                  ? `${medicine.ui_dawn_quantity} UI`
                                  : medicine.dawn_quantity
                              }}
                              {{
                                medicine.drops_dawn_quantity
                                  ? ""
                                  : medicine.ui_dawn_quantity
                                  ? ""
                                  : `${medicine.unit_of_measurement_abbreviation} (S)`
                              }}
                            </span>
                            <small>
                              VIA -
                              {{ medicine.route_of_administration_name }}
                            </small>
                          </div>
                          <div
                            v-if="medicine.morning && medicine.morning_quantity"
                          >
                            <span>MANHÃ:</span>
                            <span>
                              {{
                                medicine.drops_morning_quantity
                                  ? `${medicine.drops_morning_quantity} GOTA(S)`
                                  : medicine.ui_morning_quantity
                                  ? `${medicine.ui_morning_quantity} UI`
                                  : medicine.morning_quantity
                              }}
                              {{
                                medicine.drops_morning_quantity
                                  ? ""
                                  : medicine.ui_morning_quantity
                                  ? ""
                                  : `${medicine.unit_of_measurement_abbreviation} (S)`
                              }}
                            </span>
                            <small>
                              VIA -
                              {{ medicine.route_of_administration_name }}
                            </small>
                          </div>
                          <div
                            v-if="
                              medicine.afternoon && medicine.afternoon_quantity
                            "
                          >
                            <span>TARDE:</span>
                            <span>
                              {{
                                medicine.drops_afternoon_quantity
                                  ? `${medicine.drops_afternoon_quantity} GOTA(S)`
                                  : medicine.ui_afternoon_quantity
                                  ? `${medicine.ui_afternoon_quantity} UI`
                                  : medicine.afternoon_quantity
                              }}
                              {{
                                medicine.drops_afternoon_quantity
                                  ? ""
                                  : medicine.ui_afternoon_quantity
                                  ? ""
                                  : `${medicine.unit_of_measurement_abbreviation} (S)`
                              }}
                            </span>
                            <small>
                              VIA -
                              {{ medicine.route_of_administration_name }}
                            </small>
                          </div>
                          <div v-if="medicine.night && medicine.night_quantity">
                            <span>NOITE:</span>
                            <span>
                              {{
                                medicine.drops_night_quantity
                                  ? `${medicine.drops_night_quantity} GOTA(S)`
                                  : medicine.ui_night_quantity
                                  ? `${medicine.ui_night_quantity} UI`
                                  : medicine.night_quantity
                              }}
                              {{
                                medicine.drops_night_quantity
                                  ? ""
                                  : medicine.ui_night_quantity
                                  ? ""
                                  : `${medicine.unit_of_measurement_abbreviation} (S)`
                              }}
                            </span>
                            <small>
                              VIA -
                              {{ medicine.route_of_administration_name }}
                            </small>
                          </div>
                          <div
                            v-if="medicine.shift_5 && medicine.shift_5_quantity"
                          >
                            <span>5º:</span>
                            <span>
                              {{
                                medicine.drops_shift_5_quantity
                                  ? `${medicine.drops_shift_5_quantity} GOTA(S)`
                                  : medicine.ui_shift_5_quantity
                                  ? `${medicine.ui_shift_5_quantity} UI`
                                  : medicine.shift_5_quantity
                              }}
                              {{
                                medicine.drops_shift_5_quantity
                                  ? ""
                                  : medicine.ui_shift_5_quantity
                                  ? ""
                                  : `${medicine.unit_of_measurement_abbreviation} (S)`
                              }}
                            </span>
                            <small>
                              VIA -
                              {{ medicine.route_of_administration_name }}
                            </small>
                          </div>
                          <div
                            v-if="medicine.shift_6 && medicine.shift_6_quantity"
                          >
                            <span>6º:</span>
                            <span>
                              {{
                                medicine.drops_shift_6_quantity
                                  ? `${medicine.drops_shift_6_quantity} GOTA(S)`
                                  : medicine.ui_shift_6_quantity
                                  ? `${medicine.ui_shift_6_quantity} UI`
                                  : medicine.shift_6_quantity
                              }}
                              {{
                                medicine.drops_shift_6_quantity
                                  ? ""
                                  : medicine.ui_shift_6_quantity
                                  ? ""
                                  : `${medicine.unit_of_measurement_abbreviation} (S)`
                              }}
                            </span>
                            <small>
                              VIA -
                              {{ medicine.route_of_administration_name }}
                            </small>
                          </div>
                          <div
                            v-if="medicine.shift_7 && medicine.shift_7_quantity"
                          >
                            <span>7º:</span>
                            <span>
                              {{
                                medicine.drops_shift_7_quantity
                                  ? `${medicine.drops_shift_7_quantity} GOTA(S)`
                                  : medicine.ui_shift_7_quantity
                                  ? `${medicine.ui_shift_7_quantity} UI`
                                  : medicine.shift_7_quantity
                              }}
                              {{
                                medicine.drops_shift_7_quantity
                                  ? ""
                                  : medicine.ui_shift_7_quantity
                                  ? ""
                                  : `${medicine.unit_of_measurement_abbreviation} (S)`
                              }}
                            </span>
                            <small>
                              VIA -
                              {{ medicine.route_of_administration_name }}
                            </small>
                          </div>
                          <div
                            v-if="medicine.shift_8 && medicine.shift_8_quantity"
                          >
                            <span>8º:</span>
                            <span>
                              {{
                                medicine.drops_shift_8_quantity
                                  ? `${medicine.drops_shift_8_quantity} GOTA(S)`
                                  : medicine.ui_shift_8_quantity
                                  ? `${medicine.ui_shift_8_quantity} UI`
                                  : medicine.shift_8_quantity
                              }}
                              {{
                                medicine.drops_shift_8_quantity
                                  ? ""
                                  : medicine.ui_shift_8_quantity
                                  ? ""
                                  : `${medicine.unit_of_measurement_abbreviation} (S)`
                              }}
                            </span>
                            <small>
                              VIA -
                              {{ medicine.route_of_administration_name }}
                            </small>
                          </div>
                        </div>
                        <div
                          v-if="medicine.frequency == 'SEMANAL'"
                          class="text-thirteen"
                        >
                          Dias da semana:
                          {{ medicine.dom && "DOM" }}
                          {{ medicine.seg && "SEG" }}
                          {{ medicine.ter && "TER" }}
                          {{ medicine.qua && "QUA" }}
                          {{ medicine.qui && "QUI" }}
                          {{ medicine.sex && "SEX" }}
                          {{ medicine.sab && "SAB" }}
                        </div>
                      </div>
                    </div>
                    <div v-if="medicine.frequency == 'EVENTUAL'">EVENTUAL</div>
                    <span
                      class="text-thirteen"
                      v-if="
                        medicine.medicine_amount_of_times_name &&
                        medicine.medicine_amount_of_times_type != 'SHIFTS'
                      "
                    >
                      {{ medicine.medicine_amount_of_times_name }}:
                    </span>
                    <b
                      v-if="
                        medicine.medicine_amount_of_times_type == 'DAY' ||
                        medicine.frequency == 'EVENTUAL'
                      "
                    >
                      {{
                        `${
                          medicine.drops
                            ? `${medicine.drops} GOTA(S)`
                            : medicine.ui
                            ? `${medicine.ui} UI`
                            : medicine.quantity
                        } ${
                          medicine.drops
                            ? ""
                            : medicine.ui
                            ? ""
                            : `- ${medicine.unit_of_measurement_abbreviation} (S)`
                        }`
                      }}
                    </b>
                    <small>
                      VIA -
                      {{ medicine.route_of_administration_name }}
                    </small>
                    <div class="legends worksansr" v-if="medicine.instruction">
                      Instrução: {{ medicine.instruction }}
                    </div>
                  </div>
                </div>
                <div class="footer">
                  <div class="identificacao-do-comprador row m-0">
                    <div
                      class="identificacao-do-comprador-left col-md-7"
                      v-show="data[0].type_of_recipe_name != 'RECEITA COMUM'"
                    >
                      <h5 class="text-center m-0">
                        IDENTIFICAÇÃO DO COMPRADOR
                      </h5>
                      <div class="text-left"><b>Nome:</b></div>
                      <div class="text-left"><b>RG:</b></div>
                      <div class="text-left"><b>Endereço:</b></div>
                      <div class="text-left"><b>Telefone:</b></div>
                      <div class="text-left"><b>Cidade e UF:</b></div>
                    </div>
                    <div
                      class="identificacao-do-comprador-right col-md-5"
                      v-show="data[0].type_of_recipe_name != 'RECEITA COMUM'"
                    >
                      <h5 class="text-center m-0">
                        IDENTIFICAÇÃO DO FORNECEDOR
                      </h5>
                      <hr />
                      <div class="text-center">
                        <b style="font-size: 14px !important">DATA</b>
                      </div>
                      <hr />
                      <div class="text-center">
                        <b style="font-size: 14px !important"
                          >ASSINATURA DO FARMACÊUTICO</b
                        >
                      </div>
                    </div>
                    <div class="identificacao-do-comprador-bottom col-md-12">
                      <span>Atendimento realizado na Plataforma</span>
                      <img
                        width="150px"
                        height="30px"
                        :src="require('../assets/logo.png')"
                      />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="mt-5 mb-5 not-print text-right"
          v-if="data_qrcode.status == 0"
        >
          <v-btn class="btn-print" @click="handlePrint"
            ><i class="fas fa-print mr-2"></i> IMPRIMIR</v-btn
          >
        </div>
        <div class="mt-5 mb-5 not-print" v-if="data_qrcode.status == 1">
          <p v-if="errorsExecute.length > 0">
            {{ errorsExecute[0] }}
          </p>
          <div class="text-right">
            <confirmation-dialog
              :loading="loading"
              :disabled="loading"
              header-class="modal-header-i"
              message-title="VALIDAR RECEITA?"
              message-body="Deseja realmente validar a receita?"
              open-class="btn-save"
              open-left-icon="fa-check"
              open-text="VALIDAR RECEITA"
              @yes="execute"
            />
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import routes from "../routes";

import QRCode from "qrcode";

export default {
  name: "VerifyRecipe",

  components: { ConfirmationDialog },

  data() {
    return {
      tables: [],

      data: [],

      separateData: [],

      id: null,
      imgQRCode: null,
      data_qrcode: { status: 1 },

      doctor: { name: "", office: "", professional_class_council_value: "" },
      resident: { name: "" },
      client: { address: "", logo_url: "" },

      rest_home_id: "",
      group_prescription_medicine_id: "",
      prescription_medicine_ids: [],
      doctor_id: "",
      qrcode: "",

      errors: [],
      errorsExecute: [],

      loading: false,
      exist: true,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    retrieve() {
      let {
        rest_home_id,
        group_prescription_medicine_id,
        prescription_medicine_ids,
        doctor_id,
        qrcode,
      } = routes.currentRoute.params;

      if (
        !rest_home_id ||
        !doctor_id ||
        !group_prescription_medicine_id ||
        !prescription_medicine_ids ||
        !qrcode
      ) {
        return;
      }

      this.rest_home_id = rest_home_id;
      this.group_prescription_medicine_id = group_prescription_medicine_id;
      this.prescription_medicine_ids = prescription_medicine_ids.split(",");
      this.doctor_id = doctor_id;
      this.qrcode = qrcode;

      this.get();
    },

    async get() {
      try {
        this.loading = true;

        let {
          rest_home_id,
          group_prescription_medicine_id,
          prescription_medicine_ids,
          doctor_id,
          qrcode,
        } = this;

        let params = {
          rest_home_id,
          group_prescription_medicine_id,
          prescription_medicine_ids,
          doctor_id,
          qrcode,
        };

        const response = await api.get("/rest-home/recipe/qrcode", { params });

        const {
          error,
          errors,
          client,
          resident,
          doctor,
          data,
          data_qrcode,
          exist,
        } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.client = client;
          this.resident = resident;
          this.doctor = doctor;
          this.data = data;
          this.data_qrcode = data_qrcode;
          this.exist = exist;

          let max = data[0].type_of_recipe_name == "RECEITA COMUM" ? 8 : 8;

          this.separateData = this.separate(data, max);

          this.tables = data[0].type_of_recipe_name == "RECEITA COMUM" ? 1 : 2;

          this.id = data_qrcode.id;

          this.generateQRCode();
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    generateQRCode() {
      try {
        this.loading = true;

        let {
          client: { id: rest_home_id },
          group_prescription_medicine_id,
          prescription_medicine_ids,
          doctor_id,
          qrcode,
        } = this;

        let _this = this;

        prescription_medicine_ids = String(prescription_medicine_ids).slice();

        let url = `https://portal.sistemaclin.com.br/verify/recipe/${rest_home_id}/${group_prescription_medicine_id}/${prescription_medicine_ids}/${doctor_id}/${qrcode}`;

        QRCode.toDataURL(url)
          .then((url) => (_this.imgQRCode = url))
          .catch((err) => console.error(err));

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    separate(base, max) {
      let result = [[]];
      let group = 0;

      for (let indice = 0; indice < base.length; indice++) {
        if (result[group] === undefined) {
          result[group] = [];
        }

        result[group].push(base[indice]);

        if ((indice + 1) % max === 0) {
          group = group + 1;
        }
      }

      return result;
    },

    async execute() {
      try {
        this.loading = true;

        let {
          id,
          rest_home_id,
          group_prescription_medicine_id,
          prescription_medicine_ids,
          doctor_id,
          qrcode,
        } = this;

        let params = {
          id,
          rest_home_id,
          group_prescription_medicine_id,
          prescription_medicine_ids,
          doctor_id,
          qrcode,
        };

        const response = await api.put("/rest-home/recipe/qrcode", params);

        const { error, errors } = response.data;

        if (!error) {
          this.errorsExecute = [];
          this.get();
        } else {
          this.errorsExecute = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint() {
      window.print();
    },
  },
};
</script>

<style scoped>
.verify-recipe .identificacao-do-emitente-left {
  border: solid 3px #000;
  padding: 2px !important;
  box-sizing: border-box;
}

.verify-recipe .identificacao-do-emitente-left h4 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  text-align: center !important;
}

.verify-recipe .identificacao-do-emitente-right {
  text-align: center !important;
}

.verify-recipe .identificacao-do-comprador-left,
.verify-recipe .identificacao-do-comprador-right {
  border: solid 3px #000;
  padding: 2px !important;
  box-sizing: border-box;
}
.verify-recipe .identificacao-do-comprador-bottom {
  text-align: center;
  padding: 0;
}

.verify-recipe .header {
  display: block !important;
}

.verify-recipe .footer {
  display: block !important;
}

.verify-recipe .header-space-comum {
  height: 100px;
}

.verify-recipe .header-space-controle-especial {
  height: 280px;
}

.verify-recipe .footer,
.verify-recipe .footer-space {
  height: 200px;
}

.verify-recipe table,
.verify-recipe td,
.verify-recipe th,
.verify-recipe tfoot {
  width: 100% !important;
  cursor: auto !important;
}

.verify-recipe .header {
  position: fixed;
  top: 0;
}

.verify-recipe .table-important {
  width: 100% !important;
  cursor: auto !important;
}

.verify-recipe .medicine-text-span {
  display: none;
}

.verify-recipe .logo {
  height: 50px;
  object-fit: contain;
}
.verify-recipe .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.verify-recipe .resident_photo_url {
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

@media print {
  @page {
    size: 0;
  }

  .verify-recipe .identificacao-do-emitente-left {
    width: 60% !important;
  }

  .verify-recipe .identificacao-do-emitente-right {
    width: 40% !important;
  }

  .verify-recipe .identificacao-do-comprador-left {
    width: 60% !important;
  }

  .verify-recipe .identificacao-do-comprador-right {
    width: 40% !important;
  }

  .verify-recipe {
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
    box-sizing: border-box !important;
  }

  .verify-recipe .table-important {
    page-break-before: always !important;
    page-break-inside: avoid !important;
  }

  .verify-recipe .footer {
    position: fixed;
    bottom: 0;
    /* left: 0;
    right: 0; */
    width: 92% !important;
    max-width: 100% !important;
  }

  .verify-recipe .content {
    page-break-before: always !important;
  }

  .verify-recipe .page-break-inside-avoid {
    page-break-inside: avoid !important;
  }

  .verify-recipe .not-print {
    display: none;
  }

  .verify-recipe button {
    display: none;
  }

  .verify-recipe .table-important {
    margin: 10px !important;
  }
}
</style>